import { useWorkspaceContext } from '@/contexts/WorkspaceContext';

export function useWorkspaceScopeId(): string | null {
  const { selectedWorkspaceId } = useWorkspaceContext();
  return selectedWorkspaceId;
}
